import _ from 'lodash';
import ArticleService from '@/common/services/article.service';
import {
  SELECT_ARTICLE,
  TRY_FETCH,
  FETCH_ARTICLE,
  FETCH_FEATURED_ARTICLES,
  FETCH_ARTICLES_BY_CATEGORY,
  FETCH_RELATED_ARTICLES, TOGGLE_CATEGORY_NAV
} from '@/store/actions/article.actions';
import {
  SET_SELECTED_ARTICLE,
  SET_ARTICLES,
  SET_ARTICLES_BY_CATEGORY_LOADED,
  SET_RELATED_ARTICLES, SET_NAV_COLLAPSE
} from '@/store/mutations/article.mutations';
import { SET_ERROR } from '../mutations/common.mutations';
import { getError } from '@/common/services/http.service';

const initialState = {
  entities: [],
  selectedArticleSlug: null,
  relatedArticles: [],
  loaded: false,
  pending: false,
  navCollapsed: false,
  errors: [],
  articleCategoriesLoaded: [],
};

const state = {
  ...initialState
};

const actions = {
  [SELECT_ARTICLE](context, slug) {
    context.commit(SET_SELECTED_ARTICLE, slug);
  },
  [TOGGLE_CATEGORY_NAV](context, collapse) {
    context.commit(SET_NAV_COLLAPSE, collapse);
  },
  [FETCH_ARTICLE](context, slug) {
    context.commit(TRY_FETCH);

    return new Promise((resolve, reject) => {
      ArticleService.getArticle(slug)
        .then(data => {
          context.commit(SET_ARTICLES, [data]);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          reject(getError(response));
        });
    });
  },
  [FETCH_FEATURED_ARTICLES](context) {
    context.commit(TRY_FETCH);

    return new Promise((resolve, reject) => {
      ArticleService.getFeaturedArticles()
        .then(data => {
          context.commit(SET_ARTICLES, data);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          reject(getError(response));
        });
    });
  },
  [FETCH_ARTICLES_BY_CATEGORY](context, selectedCategoryId) {
    context.commit(TRY_FETCH);

    return new Promise((resolve, reject) => {
      ArticleService.getByCategory(selectedCategoryId)
        .then(data => {
          context.commit(SET_ARTICLES, data);
          context.commit(SET_ARTICLES_BY_CATEGORY_LOADED, selectedCategoryId);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          reject(getError(response));
        });
    })
  },
  [FETCH_RELATED_ARTICLES](context, slug) {
    context.commit(TRY_FETCH);
    context.commit(SET_RELATED_ARTICLES, []);

    let selectedArticle = state.entities.find(article => article.slug === slug);
    let relatedArticles = state.entities.filter(article => selectedArticle.related_article_slugs.includes(article.slug));

    if (relatedArticles.length === selectedArticle.related_article_slugs.length){
      return context.commit(SET_RELATED_ARTICLES, relatedArticles);
    }

    let articlesToBeLoaded = [];
    for (let slug of selectedArticle.related_article_slugs){
      if(!state.entities.some(article => article.slug === slug)){
        articlesToBeLoaded.push(slug);
      }
    }

    return new Promise((resolve, reject) => {
      ArticleService.getRelatedArticles(articlesToBeLoaded)
        .then(data => {
          // add new articles to those already loaded
          relatedArticles.push(...data);

          context.commit(SET_ARTICLES, data);
          context.commit(SET_RELATED_ARTICLES, relatedArticles);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          reject(getError(response));
        });
    });
  }
};

const mutations = {
  [TRY_FETCH](state) {
    state.pending = true;
    state.errors = [];
  },
  [SET_SELECTED_ARTICLE](state, slug) {
    state.selectedArticleSlug = slug;
  },
  [SET_ARTICLES](state, articles) {
    state.entities = _.uniqBy([...state.entities, ...articles], 'id');
    state.pending = false;
    state.errors = [];
  },
  [SET_RELATED_ARTICLES](state, articles){
    state.relatedArticles = articles;
    state.pending = false;
    state.errors = [];
  },
  [SET_ARTICLES_BY_CATEGORY_LOADED](state, categoryId) {
    state.articleCategoriesLoaded.push(categoryId);
  },
  [SET_ERROR](state, errors) {
    state.pending = false;
    state.errors = errors;
  },
  [SET_NAV_COLLAPSE](state, collapse) {
    state.navCollapsed = collapse;
  }
};

const getters = {
  articles(state) {
    return state.entities;
  },
  articlesPending(state) {
    return state.pending;
  },
  selectedArticle(state) {
    return state.entities.find(article => article.slug === state.selectedArticleSlug);
  },
  getArticleBySlug: state => slug => {
    return state.entities.find(article => article.slug === slug);
  },
  relatedArticles(state) {
    return state.relatedArticles;
  },
  getArticleCategoriesLoaded: (state) => (categoryId) => {
    return state.articleCategoriesLoaded.includes(categoryId);
  },
  navCollapsed(state) {
    return state.navCollapsed;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
